export enum ExportType {
  RAW_DATA = -1,
  DATA = -2,
  REPORT = -3,
}
